import { api } from "@redux/api";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import coveragesSlice, { CoveragesState } from "./coverages/coveragesSlice";
import eventSlice, { EventSlice } from "./event/eventSlice";
import { restApi } from "./restApi";
import { SetupStoreOptions } from "@covertree/types";

export const rootReducer = combineReducers({
  coverages: coveragesSlice.reducer,
  event: eventSlice.reducer,
  [api.reducerPath]: api.reducer,
  [restApi.reducerPath]: restApi.reducer,
});

export type RootState = {
  coverages: CoveragesState;
  event: EventSlice;
};

export const setupStore = (options?: SetupStoreOptions<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware(options?.middlewareOptions).concat([
        api.middleware,
        restApi.middleware,
      ]),
    preloadedState: options?.preloadedState,
  });

export const store = setupStore({
  middlewareOptions: {
    serializableCheck: false,
  },
});

export const resetCache = () => {
  store.dispatch(api.util.resetApiState());
  store.dispatch(restApi.util.resetApiState());
};
export type AppDispatch = typeof store.dispatch;
